import React, {Component} from 'react';
import PriceListConnector from '../../../containers/price_list_container';
import ReactTable from 'react-table';
import {Button, Form, Grid, Header, Input, Popup} from 'semantic-ui-react';
import Loader from '../../universal/loader';

class ClerkPriceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPrice: undefined,
            type: 'inv'
        }
    }

    componentWillMount() {
        this.props.getClerkPriceList(this.state.type);
    }

    handlePriceChange = (value) => {
        if (this.state.newPrice) {
            this.props.updateClerkPriceList(value.id, this.state.newPrice, this.state.type);
        }
        this.setState({newPrice: undefined});
    };

    changePriceComponent = (value) => {
        return (
            <Popup
                trigger={<span className="company-price">£ {value.price}</span>}
                content={<div>
                    <Form>
                        <Input icon='pound' iconPosition='left' type='number' name='price'
                               defaultValue={value.price} onChange={(e) => {
                            this.setState({newPrice: e.target.value})
                        }}/>
                        <Button primary content='Change price'
                                onClick={(e) => this.handlePriceChange(value)}/>
                    </Form>
                </div>}
                on='click'
                wide
                flowing
                position='right center'
                hideOnScroll
            />
        )
    };

    render() {
        const columns = [{
            Header: '',
            accessor: 'type',
            headerClassName: 'col-wide',
            className: 'format-capitalize format-bold col-wide'
        }, {
            Header: 'Studio',
            accessor: 'studioBR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: '1 BR',
            accessor: '1BR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: '2 BR',
            accessor: '2BR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: '3 BR',
            accessor: '3BR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: '4 BR',
            accessor: '4BR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: '5 BR',
            accessor: '5BR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: '6 BR',
            accessor: '6BR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: '7 BR',
            accessor: '7BR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: '8 BR & Above',
            accessor: '8 & AboveBR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }, {
            Header: 'Abort',
            accessor: 'abortBR',
            Cell: ({value}) => (
                this.changePriceComponent(value)
            ),
            filterable: false
        }];

        let priceList = [];
        if (this.props.clerkPriceData.furnished) {
            let furnish = {};
            let unfurnish = {};
            let semifurnish = {};
            for (let i = 0; i < this.props.clerkPriceData.furnished.length; i++) {
                const br = this.props.clerkPriceData.furnished[i]['property_size'] + "BR";
                furnish[br] = this.props.clerkPriceData.furnished[i];
            }
            for (let i = 0; i < this.props.clerkPriceData.unfurnished.length; i++) {
                const br = this.props.clerkPriceData.furnished[i]['property_size'] + "BR";
                unfurnish[br] = this.props.clerkPriceData.unfurnished[i];
            }
            for (let i = 0; i < this.props.clerkPriceData.semifurnished.length; i++) {
                const br = this.props.clerkPriceData.furnished[i]['property_size'] + "BR";
                semifurnish[br] = this.props.clerkPriceData.semifurnished[i];
            }
            priceList.push({type: 'Unfurnished', ...unfurnish});
            priceList.push({type: 'Part-Furnished', ...semifurnish});
            priceList.push({ type: 'Furnished', ...furnish });         
        }
        const insType = {'inv': 'Inventory', 'inv/ci': 'Inventory Check-In', 'ci': 'Check-In', 'co': 'Check-Out'};
        return (
            <div>
                <div className="ui one column stackable inspection-table  aligned page grid">
                    <Header
                        content={<div><span>Clerk price list for type </span><span>"{insType[this.state.type]}"</span>
                        </div>} size='large' textAlign='center'/>
                    {this.props.isPriceFetching ? <Loader/> : <div className="column twelve">
                        <div className="pad-bottom">
                            <Grid columns={4}>
                                <Grid.Row>
                                    <Grid.Column>
                                        <Button primary={this.state.type === 'inv'} content="Inventory" fluid onClick={() => {
                                            this.setState({type: 'inv'});
                                            this.props.getClerkPriceList('inv');
                                        }}/>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Button primary={this.state.type === 'inv/ci'} content="Inventory/Check-In" fluid onClick={() => {
                                            this.setState({type: 'inv/ci'});
                                            this.props.getClerkPriceList('inv/ci');
                                        }}/>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Button primary={this.state.type === 'ci'} content="Check-In" fluid onClick={() => {
                                            this.setState({type: 'ci'});
                                            this.props.getClerkPriceList('ci');
                                        }}/>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Button primary={this.state.type === 'co'} content="Check-Out" fluid onClick={() => {
                                            this.setState({type: 'co'});
                                            this.props.getClerkPriceList('co');
                                        }}/>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                        {priceList[0] &&
                        <ReactTable
                            data={priceList}
                            columns={columns}
                            defaultFilterMethod={(filter, row, column) => {
                                const id = filter.pivotId || filter.id;
                                return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                            }}
                            defaultPageSize={10}
                            minRows={0}
                            showPagination={false}
                            sortable={false}
                            resizable={false}
                        />
                        }
                    </div>}
                </div>
            </div>);
    }

}

export default PriceListConnector(ClerkPriceList);


// WEBPACK FOOTER //
// ./src/views/user/clerk/clerk_price_list.js